<template>
  <v-pull-to-refresh @load="reloadPage">
    <AppHeader :is_icon="false" :is_back="true" :title="''" type="none" />
    <div class="like-list" ref="scrollContainer">
      <div class="page">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-6">
              <div style="padding: 0 8px">
                <div
                  style="
                    padding-top: 0px;
                    padding-bottom: 10px;
                    font-size: 20px;
                    font-weight: bold;
                    color: #827490;
                  "
                >
                  待ち合わせマッチング設定
                </div>
                <div
                  style="
                    padding: 0px 0px 20px 0;
                    font-size: 12px;
                    font-weight: 400;
                  "
                >
                  マッチングしたお相手と最初に待ち合わせする場所を設定することでスムーズに出会えます
                </div>
                <div
                  class="card"
                  style="margin-bottom: 10px"
                  v-for="(store, i) in stores"
                  :key="i"
                >
                  <div class="card-body">
                    <div class="row">
                      <div class="col-3">
                        <img
                          :src="require(`@/assets/appointment/${store.image}`)"
                          style="width: 100%; border-radius: 50%"
                        />
                      </div>
                      <div class="col text-end">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value=""
                          v-bind:checked="store.storeSelected"
                          v-on:change="
                            setStoreSelected(i, store.storeSelected, store.key)
                          "
                          style="width: 20px; height: 20px"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <div style="font-weight: bold; padding-top: 5px">
                          {{ store.name }}
                        </div>
                        <div
                          style="font-size: 12px; padding: 5px 0"
                          v-html="store.detail"
                        ></div>
                        <div style="font-size: 12px">
                          <a :href="store.url" target="_blank">{{
                            store.url
                          }}</a>
                          <div>
                            <i class="bi bi-geo-alt-fill"></i
                            >{{ store.address }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      style="
        position: fixed;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 75px;
        padding: 5px 8px;
        background-color: #fff;
      "
    >
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-6" style="height: 65px; background-color: #fff">
            <button
              type="button"
              style="width: 100%; height: 40px"
              class="btn btn-kinkyer m-plus-medium"
              @click="update"
            >
              待ち合わせに設定する
            </button>
          </div>
        </div>
      </div>
    </div>
  </v-pull-to-refresh>
  <div
    v-show="isEdit"
    style="
      position: fixed;
      top: 0px;
      width: 100%;
      height: 100%;
      background-color: rgb(0 0 0 / 50%);
      margin: 0 auto;
      padding-top: 200px;
      text-align: center;
      z-index: 999;
    "
  >
    <div style="position: absolute; z-index: 9999; width: 100%">
      <VueSpinnerBars size="50" color="#fff" />
    </div>
  </div>
</template>

<script>
import { nextTick } from "vue";
import { VPullToRefresh } from "vuetify/labs/VPullToRefresh";
import AppHeader from "@/components/HeaderView.vue";
import { db } from "../../plugins/firebase";
import { doc, updateDoc, setDoc } from "firebase/firestore";
import { store, setUser } from "../../plugins/store";

export default {
  data() {
    return {
      user: {},
      isEdit: false,
      selectStore: "",
      selectStoreInfo: {},
      stores: [
        {
          key: "bar_tied_up",
          image: "bar_tied_up.jpg",
          name: "-BAR-Tied-up",
          detail:
            "お靴を脱いでのお座敷BAR<br />ゴロゴロ転がるもよし気軽にお立ち寄りください。<br />DMは気づけない場合もございます。当日のお問い合わせは07065286655まで♪︎",
          url: "https://x.com/bar_tied_up",
          address: "東京都新宿区歌舞伎町2-9-18ライオンズプラザ地下1階",
          storeSelected: false,
        },
        {
          key: "SyuusakuSalonR",
          image: "SyuusakuSalonR.jpg",
          name: "性癖サロン ガルーダ",
          detail:
            "主従系エスエマー周策が、貴方が性的にマイノリティでいて良い空間と自慢の手間ひまカレーをご提供。大阪市北区。<br />SMや緊縛の仲間との交流や出会いにご利用下さい。<br />居心地重視、初心者優遇、あなたの界隈ライフの充実を応援します。<br />会費は戸籍に準じます。20歳未満利用不可",
          url: "https://x.com/SyuusakuSalonR",
          address: "大阪府大阪市北区鶴野町4-A コープ野村梅田618号",
          storeSelected: false,
        },
        {
          key: "artcafepandacco",
          image: "artcafepandacco.jpg",
          name: "アートカフェ&バーぱんだっこ🐼",
          detail:
            "🐼店主自らセレクトした作家さん達のイラスト、小物、雑貨に出会えるパンダだらけのカフェ＆バー🍰⭐️個展やグループ展なども開催出来ます✨店内にはパンダが300匹以上🐼",
          url: "https://lit.link/artcafepandacco",
          address:
            "福岡県福岡市中央区薬院2丁目16-11エステートモア薬院JOY 201号",
          storeSelected: false,
        },
        {
          key: "TittyTwister_78",
          image: "TittyTwister_78.jpg",
          name: "Titty Twister",
          detail:
            "東京都新宿区歌舞伎町2丁目10-6 ピア新宿4階 TEL:03-6278-9090 【営業時間】 火～金 19:00～24:00頃 土 20:00～Last 【定休日】 日曜日・月曜日 （※日・月は、不定期オープン）",
          url: "https://www.tittytwister.jp/",
          address: "東京都新宿区歌舞伎町2丁目10-6 ピア新宿4階",
          storeSelected: false,
        },
        {
          key: "arcadia_osaka",
          image: "arcadia_osaka.jpg",
          name: "大阪 SM Bar ARCADIA",
          detail:
            "当店は、マイノリティーな嗜好をお持ちの紳士淑女が集う居場所(スペース)です。SMや緊縛・ボンテージやアブノーマル等の嗜好をお持ちの皆様が安心して楽しく過ごせる大人の社交場をご提供いたします。",
          url: "http://bar-arcadia.com/",
          address: "大阪市北区堂山町10-7 ステージジュエルビル4F",
          storeSelected: false,
        },
        {
          key: "smbar_mirage",
          image: "smbar_mirage.jpg",
          name: "SM Bar ミラージュ",
          detail:
            "____錦糸町駅南口徒歩5分____関東最大級のSM Bar ___ ⏰【営業時間】⏰月〜金17:00〜23:30土日13:00〜23:30🍺【時間制限無し飲み放題】🍺SM好きの為の集いの場👠",
          url: "http://bar-arcadia.com/",
          address:
            "東京都墨田区, 江東橋4丁目13-13ロイヤルガーデン８ビル地下一階",
          storeSelected: false,
        },
        {
          key: "lycoris_kokura",
          image: "lycoris_kokura.jpg",
          name: "-Fetish Bar- LYCORIS",
          detail:
            "緊縛,拘束具,ボンデージ衣装等…フェティッシュな空間をご提供致します。▼飲み放題制【女性ﾌﾘｰﾀｲﾑ:¥2,000】、【男性90分:¥6,000〜/🆓¥10,000】⭐️学割、男女ペア割、コスプレ割がお得！⭐️各種電子決済可",
          url: "https://x.com/lycoris_kokura",
          address: "福岡県北九州市小倉北区紺屋町8-16 麻布21ビル･6階",
          storeSelected: false,
        },
        {
          key: "h_shadowface",
          image: "h_shadowface.png",
          name: "博多西中洲KINKY BOX",
          detail:
            "古き良きSMの文化と、次世代型フェティッシュが融合する、KINKY（へんたい）達の為の箱。 開けてみればそこは、,脳裏に刺さるアートな空間。 背徳の美学、精神の開放と癒しをあなたへ。（旧バガボンボン）",
          url: "https://kinkybox.jp/",
          address: "福岡県福岡市中央区西中洲3-26西中洲アスコットテラス4A",
          storeSelected: false,
        },
      ],
    };
  },
  created() {
    this.user = store.user;
    this.selectStore =
      this.user.isAppointment == undefined ? "" : this.user.selectStore;
    this.stores.forEach((store) => {
      store.storeSelected = store.key === this.selectStore;
      if (store.key === this.selectStore) {
        this.selectStoreInfo = store;
      }
    });
  },
  components: {
    AppHeader,
    VPullToRefresh,
  },
  watch: {
    // データが変更されたときにスクロールをリセット
    content: {
      async handler() {
        await nextTick();
        if (this.$refs.scrollContainer) {
          window.scrollTo(0, 0);
        }
      },
      immediate: true,
    },
  },
  methods: {
    async update() {
      try {
        const docUpdateUsersRef = doc(db, "users", this.user.uid);

        await updateDoc(docUpdateUsersRef, {
          isAppointment: this.selectStore != "",
          selectStore: this.selectStore,
          selectStoreName:
            this.selectStore != "" ? this.selectStoreInfo.name : "",
          selectStoreImage:
            this.selectStore != "" ? this.selectStoreInfo.image : "",
        });
        await setDoc(doc(db, "shareUsers", this.user.uid), {
          isAppointment: this.selectStore != "",
          selectStore: this.selectStore,
        });

        this.user.isAppointment = this.selectStore != "";
        this.user.selectStore = this.selectStore;

        setUser(this.user, this.user.uid);

        this.$router.go(-1);
      } catch (error) {
        this.isEdit = false;
        console.error("Error :", error);

        this.$toast.show("登録時にエラーが発生しました", {
          type: "error",
          position: "bottom",
          duration: 2000,
        });
        return;
      }
    },
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    setStoreSelected(i, flg, key) {
      this.stores.forEach((store) => {
        store.storeSelected = false;
      });
      this.stores[i].storeSelected = !flg;

      if (this.stores[i].storeSelected) {
        this.selectStore = key;
        this.selectStoreInfo = this.stores[i];
      } else {
        this.selectStore = "";
        this.selectStoreInfo = {};
      }
    },
  },
};
</script>

<style scoped>
.like-list {
  animation: fadeIn 1.2s cubic-bezier(0.33, 1, 0.68, 1) 1 forwards;
  height: 100%;
  background-color: #fff;
}
.page {
  padding-top: 80px;
  padding-bottom: 80px;
}
.form-check-input:checked {
  background-color: #784ba0;
  border-color: #784ba0;
}
</style>
